module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": ['Referral/Application Dashboard']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.referralId) ? _c('referral-submission', {
    attrs: {
      "id": _vm.referralId
    }
  }) : _c('p', [_vm._v("No referral selected. Please select a referral from the Referral Feed.")])], 1)])]), _vm._v(" "), _c('referral-feed', {
    attrs: {
      "movable": false
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v("Referral/Application Submission")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca3cf6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReferralDashboard/ReferralDashboard.vue
// module id = 1574
// module chunks = 1